export const SEARCH = 'SEARCH';
export const LOAD_PATIENT = 'LOAD_PATIENT';